import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { Box, Typography, FormControl, Select, MenuItem, TextField, CircularProgress, Button, Avatar } from '@mui/material';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import userimg from '../../../assets/images/user_img.png';
import { useDispatch, useSelector } from "react-redux";
import { fetchDrivers } from '../../../redux/slices/DriverSlice';
import { Edit } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const MyTable = () => {
  const dispatch = useDispatch();
  const { alldrivers, loading, error } = useSelector((state) => state.getdrivers);

  useEffect(() => {
    dispatch(fetchDrivers());
  }, [dispatch]);

  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');
  const [page, setPage] = useState(1);
  const navigate = useNavigate();

  // Format data to match expected table structure
  const formattedData = alldrivers?.drivers?.map((order) => ({
    id: order._id,
    image: order?.profileImage || userimg, // Use driver's profile image or a placeholder
    driverName: order.name || "Unknown",
    orderCompleted: order?.orderCount   ,
  })).reverse() || [];

  // Handle search filter
  const filteredData = formattedData.filter(item =>
    item.id.toString().includes(searchTerm) ||
    item.driverName.toLowerCase().includes(searchTerm.toLowerCase()) ||
    String(item.orderCompleted).toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Handle pagination
  const startIndex = (page - 1) * entriesPerPage;
  const currentPageData = filteredData.slice(startIndex, startIndex + entriesPerPage);

  // Table columns
  const columns = [
    { 
      name: 'Image', 
      selector: row => row.image,
      cell: row => (
              <Box sx={{ display: 'flex', alignItems: 'center' ,paddingY:1}}>
                <img
                  src={row.image}
                  alt={row.UserName}
                  style={{ width: 50, height: 50, objectFit: 'cover', marginRight: 8 }}
                />
              </Box>
            ),
      sortable: false,
    },
    { 
      name: 'Driver', 
      selector: row => row.driverName, 
      sortable: true 
    },
    { 
      name: 'Order Completed', 
      selector: row => row.orderCompleted,
      sortable: true,
      cell: row => (
        <Typography sx={{ fontSize: '14px'}}>
          {row.orderCompleted}
        </Typography>
      ),
    },
    {
      name: 'Actions',
      cell: row => (
        <Edit
                    sx={{
                      cursor: 'pointer',
                      backgroundColor: 'green',
                      color: '#fff',
                      borderRadius: '50%',
                      padding: '5px',
                      fontSize: '28px',
                    }}
                    onClick={() => navigate(`/edit/${row.id}`)}
                  />
      ),
    },
  ];

  return (
    <div>
      {/* Show loading state */}
      {loading && <CircularProgress sx={{ display: 'block', margin: '20px auto' }} />}
      {error && <Typography color="error">{error}</Typography>}

      {!loading && !error && (
        <>
          {/* Entries per Page and Search Bar Section */}
          <Box sx={{ display: 'flex',flexWrap:'wrap', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="body1" sx={{ mr: 1 }}>Show</Typography>
              <FormControl sx={{ p: 1 }}>
                <Select
                  value={entriesPerPage}
                  onChange={(e) => { setEntriesPerPage(e.target.value); setPage(1); }}
                >
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={25}>25</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                  <MenuItem value={100}>100</MenuItem>
                </Select>
              </FormControl>
              <Typography variant="body1" sx={{ mr: 1 }}>entries</Typography>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="body1" sx={{ mr: 1 }}>Search:</Typography>
              <TextField
                variant="outlined"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                size="small"
              />
            </Box>
          </Box>

          {/* DataTable */}
          <DataTable
            columns={columns}
            data={currentPageData}
            pagination
            paginationServer
            paginationTotalRows={filteredData.length}
            onChangePage={(newPage) => setPage(newPage)}
            paginationPerPage={entriesPerPage}
            paginationComponentOptions={{ noRowsPerPage: true }}
            customStyles={{
              headCells: { style: { fontSize: '16px', fontWeight: 'bold', color: '#333' } },
              cells: { style: { fontSize: '14px', color: '#3c7f06', fontWeight: '300' } },
            }}
          />
        </>
      )}
    </div>
  );
};

export default MyTable;
